import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import { ContractStage } from '../../../models/Entities/Contracts/ContractStage';

export default function ContractStagesByContractReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;
  switch (a.type) {
    case 'CONTRACTSTAGE_GET_ALL_BY_CONTRACTID_RECEIVE_ACTION': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      return {
        ...currentState,
        list: contract
          ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), { ...contract, stages: a.contractStages as ContractStage[] }]
          : currentState.list,
      };
    }
    case 'CONTRACTSTAGE_UPDATE_ALL_BY_CONTRACTID_RECEIVE_ACTION': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      return {
        ...currentState,
        list: contract
          ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), { ...contract, stages: a.contractStages as ContractStage[] }]
          : currentState.list,
      };
    }
    case 'CONTRACTSTAGE_GET_BY_ID_RECEIVE_ACTION': {
      const contract = (currentState.list || []).find((item: Contract) => item.id === a.contractStage.contractId);
      return {
        ...currentState,
        list: contract
          ? [...(currentState.list || []).filter((item: Contract) => item.id !== contract!.id), { ...contract, stages: (contract.stages || []).filter((s: any) => s.id !== a.contractStage.id).concat([a.contractStage]) }]
          : currentState.list,
      };
    }
    default:
      return currentState;
  }
}
